export const CalcTypes = {
  lite: 'lite'
}

export const ConstructionTypes = {
  floor: 'floor',
  wall: 'wall',
  ceiling: 'ceiling'
}

export const Structures = {
  sizes: 'sizes',
  facing: 'facing',
  base: 'base',
  soundIsolation: 'soundIsolation',
  screed: 'screed',
  isolation: 'isolation',
  facingInnerLayer: 'facingInnerLayer'
}

export const Layers = {
  outer: 'outer',
  inner: 'inner'
}

export const SizeParams = {
  y: 'y', // высота или ширина
  x: 'x' // длина
}

export const Params = {
  sheets: 'sheets',
  facing: 'facing',
  density: 'density',
  thickness: 'thickness'
}

export const InputType = {
  integer: 'int',
  float: 'float',
  text: 'text'
}
